/**
 * @generated SignedSource<<14bbd4e27dbcb4fef87c6ee9d75ba788>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ArchivedPageBannerV2_content$data = {
  readonly archivedContentMetadata: {
    readonly archiveNote: string | null;
  } | null;
  readonly history: {
    readonly lastUpdated: {
      readonly by: {
        readonly accountId?: string | null;
      } | null;
    } | null;
  } | null;
  readonly id: string | null;
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly type: string | null;
  readonly " $fragmentType": "ArchivedPageBannerV2_content";
};
export type ArchivedPageBannerV2_content$key = {
  readonly " $data"?: ArchivedPageBannerV2_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2_content">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ArchivedPageBannerV2_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    },
    {
      "concreteType": "ArchivedContentMetadata",
      "kind": "LinkedField",
      "name": "archivedContentMetadata",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "archiveNote"
        }
      ]
    },
    {
      "concreteType": "History",
      "kind": "LinkedField",
      "name": "history",
      "plural": false,
      "selections": [
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "lastUpdated",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "by",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": (v0/*: any*/),
                  "type": "KnownUser"
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v0/*: any*/),
                  "type": "UnknownUser"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "5d436ce04af0e59d7af1d44cc8ac90df";

export default node;
